import { JetView } from 'webix-jet';
import { devConfig } from 'config/config';
export default class tableSaveAccountView extends JetView {
    config() {
        const _ = this.app.getService('locale')._;
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat);
        var vthis = this;
        return {
            view: 'datatable',
            id: 'datatable',
            css: 'webix_header_border webix_data_border webix_footer_border',
            select: true,
            scrollY: screen.width < 820 ? false : true,
            columns: [
                {
                    id: 'rating',
                    header: '',
                    width: 50,
                    height: 25,
                    tooltip: 'Editar',
                    template: function (obj) {
                        if (devConfig.getPermAction('accountingAccountsEdit', 'Edit')) {
                            return "<span class='webix_icon wxi-close edit'></span>";
                        } else {
                            return '';
                        }
                    },
                },
                {
                    id: 'Reference',
                    header: _('Cuenta'),
                    width: 100,
                    sort: 'int',
                },
                { id: 'Name', header: _('Nombre'), width: 250, sort: 'int' },
                {
                    id: 'State',
                    header: _('Estado'),
                    editor: 'combo',
                    options: [
                        { id: 'A', value: _('Activado') },
                        { id: 'I', value: _('Inactivado') },
                    ],
                    width: 100,
                    sort: 'int',
                },
                {
                    id: 'AccountCancellation',
                    header: _('Cuenta de cancelación'),
                    width: 100,
                    sort: 'int',
                },
            ],
            onClick: {
                edit: function (euv, id) {
                    vthis.app.callEvent('openEdit', [{}]);
                },
            },
            tooltip: true,
            math: true,
            loadahead: devConfig.getDefaultDataFetch(),
            pager: 'pagerA',
            url: devConfig.geturlApi() + 'Accounting/GetAccounts',
            data: [],
        };
    }
    init(grid) {
        var url = grid.data.url;
        var filter = '';
        const _ = this.app.getService('locale')._;
        var accounts = [];
        var popup = '';
        var popupAdd = '';
        webix
            .ajax()
            .headers({
                'Content-type': 'application/json',
            })
            .post(devConfig.geturlApi() + 'Accounting/GetAccountsSelect', '', {
                error: function (text, data, XmlHttpRequest) {
                    webix.message(_('Error! '));
                },
                success: function (text, data, XmlHttpRequest) {
                    var resp = JSON.parse(text);
                    accounts = resp.Data;
                    popup = webix.ui({
                        view: 'window',
                        id: 'EditSaveAccount',
                        width: 390,
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Editar Cuenta') },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide();
                                    },
                                },
                            ],
                        },
                        position: 'center',
                        modal: true,
                        body: {
                            view: 'form',
                            id: 'editForm',
                            elements: [
                                {
                                    view: 'text',
                                    label: 'ID',
                                    name: 'Id',
                                    readonly: true,
                                },
                                {
                                    view: 'text',
                                    label: _('Cuenta'),
                                    name: 'Reference',
                                },
                                {
                                    view: 'text',
                                    label: _('Nombre'),
                                    name: 'Name',
                                },
                                {
                                    view: 'combo',
                                    label: _('Estado'),
                                    name: 'State',
                                    options: [
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo',
                                            label: _('Cuenta de cancelación'),
                                            name: 'AccountCancellation',
                                            options: accounts,
                                            labelWidth: 170,
                                            id: 'selectAccount',
                                            placeholder: _('Click para seleccionar '),
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button',
                                            view: 'button',
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass',
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Plan de Cuentas'),
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close',
                                                                    click: function () {
                                                                        this.getTopParentView().hide();
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchAccount',
                                                        modal: true,
                                                        position: 'center',
                                                        width: 390,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable',
                                                                    select: true,
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id',
                                                                                {
                                                                                    content: 'textFilter',
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'),
                                                                                {
                                                                                    content: 'textFilter',
                                                                                },
                                                                            ],
                                                                            fillspace: true,
                                                                        },
                                                                    ],
                                                                    data: accounts,
                                                                    on: {
                                                                        onItemDblClick: function (id) {
                                                                            var item = this.getItem(id);
                                                                            $$('selectAccount').setValue(item.id);
                                                                            $$('searchAccount').hide();
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show();
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'),
                                            click: function () {
                                                this.getTopParentView().hide();
                                                $$('editForm').setValues($$('editForm').getCleanValues());
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'),
                                            click: function ($e) {
                                                var values = $$('editForm').getValues();
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Accounting/SaveAccount',
                                                        '{"Id":"' +
                                                            values.Id +
                                                            '", "Name":"' +
                                                            values.Name +
                                                            '", "State":"' +
                                                            values.State +
                                                            '", "Reference":"' +
                                                            values.Reference +
                                                            '", "AccountCancellation":"' +
                                                            values.AccountCancellation +
                                                            '"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Cuenta Actualizado'));
                                                                grid.clearAll();
                                                                grid.load(
                                                                    url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter,
                                                                );
                                                            },
                                                        },
                                                    );
                                                $$('editForm').setValues($$('editForm').getCleanValues());
                                                this.getTopParentView().hide();
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                    $$('editForm').bind($$('datatable'));
                    popupAdd = webix.ui({
                        view: 'window',
                        id: 'AddSaveAccount',
                        width: 390,
                        head: {
                            view: 'toolbar',
                            cols: [
                                { view: 'label', label: _('Añadir Cuenta') },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close',
                                    click: function () {
                                        this.getTopParentView().hide();
                                    },
                                },
                            ],
                        },
                        position: 'center',
                        modal: true,
                        body: {
                            view: 'form',
                            id: 'addform',
                            elements: [
                                {
                                    view: 'text',
                                    label: _('Cuenta'),
                                    name: 'Reference',
                                },
                                {
                                    view: 'text',
                                    label: _('Nombre'),
                                    name: 'Name',
                                },
                                {
                                    view: 'combo',
                                    label: _('Estado'),
                                    name: 'State',
                                    options: [
                                        { id: 'A', value: _('Activado') },
                                        { id: 'I', value: _('Inactivado') },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'combo',
                                            label: _('Cuenta de cancelación'),
                                            name: 'AccountCancellation',
                                            options: accounts,
                                            labelWidth: 170,
                                            id: 'selectAccountAdd',
                                            placeholder: _('Click para seleccionar '),
                                        },
                                        {
                                            width: 30,
                                            css: 'back-button',
                                            view: 'button',
                                            type: 'icon',
                                            icon: 'icon-magnifying-glass',
                                            align: 'center',
                                            click: () => {
                                                webix
                                                    .ui({
                                                        view: 'window',
                                                        head: {
                                                            view: 'toolbar',
                                                            cols: [
                                                                {
                                                                    view: 'label',
                                                                    label: _('Plan de Cuentas'),
                                                                    align: 'center',
                                                                },
                                                                {
                                                                    view: 'icon',
                                                                    icon: 'wxi-close',
                                                                    click: function () {
                                                                        this.getTopParentView().hide();
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                        id: 'searchAccountAdd',
                                                        modal: true,
                                                        position: 'center',
                                                        width: 390,
                                                        height: 425,
                                                        body: {
                                                            rows: [
                                                                {
                                                                    view: 'datatable',
                                                                    select: true,
                                                                    columns: [
                                                                        {
                                                                            id: 'id',
                                                                            header: [
                                                                                'Id',
                                                                                {
                                                                                    content: 'textFilter',
                                                                                },
                                                                            ],
                                                                            width: 70,
                                                                        },
                                                                        {
                                                                            id: 'value',
                                                                            header: [
                                                                                _('Nombre'),
                                                                                {
                                                                                    content: 'textFilter',
                                                                                },
                                                                            ],
                                                                            fillspace: true,
                                                                        },
                                                                    ],
                                                                    data: accounts,
                                                                    on: {
                                                                        onItemDblClick: function (id) {
                                                                            var item = this.getItem(id);
                                                                            $$('selectAccountAdd').setValue(item.id);
                                                                            $$('searchAccountAdd').hide();
                                                                        },
                                                                    },
                                                                },
                                                            ],
                                                        },
                                                    })
                                                    .show();
                                            },
                                        },
                                    ],
                                },
                                {
                                    cols: [
                                        {
                                            view: 'button',
                                            value: _('Cancelar'),
                                            click: function () {
                                                this.getTopParentView().hide();
                                                $$('addform').setValues($$('addform').getCleanValues());
                                            },
                                        },
                                        {
                                            view: 'button',
                                            type: 'form',
                                            value: _('Guardar'),
                                            click: function ($e) {
                                                var values = $$('addform').getValues();
                                                webix
                                                    .ajax()
                                                    .headers({
                                                        'Content-type': 'application/json',
                                                    })
                                                    .post(
                                                        devConfig.geturlApi() + 'Accounting/SaveAccount',
                                                        '{"Name":"' +
                                                            values.Name +
                                                            '", "State":"' +
                                                            values.State +
                                                            '", "Reference":"' +
                                                            values.Reference +
                                                            '", "AccountCancellation":"' +
                                                            values.AccountCancellation +
                                                            '"}',
                                                        {
                                                            error: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Error! '));
                                                            },
                                                            success: function (text, data, XmlHttpRequest) {
                                                                webix.message(_('Cuenta Agregado'));
                                                                grid.clearAll();
                                                                grid.load(
                                                                    url +
                                                                        '?start=0&count=' +
                                                                        grid.data.$pagesize +
                                                                        filter,
                                                                );
                                                            },
                                                        },
                                                    );
                                                $$('addform').setValues($$('addform').getCleanValues());
                                                this.getTopParentView().hide();
                                            },
                                        },
                                    ],
                                },
                            ],
                        },
                    });
                },
            });
        this.on(this.app, 'Account:filter', (filterData) => {
            var object = Object.entries(filterData);
            var string1 = '';
            for (var i = 0; i < object.length; i++) {
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    if (object[i][0] == 'CreatedLocalDate') {
                        var date = object[i][1].split(' - ');
                        string1 = string1 + '&dateFrom=' + date[0];
                        string1 = string1 + '&dateTo=' + date[1];
                    } else {
                        if (object[i][0] == 'ModifiedLocalDate') {
                            var date = object[i][1].split(' - ');
                            string1 = string1 + '&dateFrom2=' + date[0];
                            string1 = string1 + '&dateTo2=' + date[1];
                        } else {
                            string1 = string1 + '&' + object[i][0] + '=' + object[i][1];
                        }
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        var object2 = Object.entries(object[i][1]);
                        for (var j = 0; j < object2.length; j++) {
                            if (object2[j][1] !== null) {
                                if (object2[j][0] === 'start') {
                                    var d = new Date(object2[j][1]);
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2);
                                    string1 = string1 + '&' + dateFrom;
                                } else {
                                    if (object2[j][0] === 'end') {
                                        var d = new Date(object2[j][1]);
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2);
                                        string1 = string1 + '&' + dateTo;
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll();
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1);
            filter = string1;
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir);
        });
        this.on(this.app, 'addAccount:button', (filter) => {
            if (accounts.length > 0) {
                $$('addform').clearValidation();
                popupAdd.show();
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });
        this.on(this.app, 'openEdit', (filterData) => {
            if (accounts.length > 0) {
                popup.show();
            } else {
                webix.message({
                    text: _('Datos no han podido ser cargados'),
                    title: _('¡Error!'),
                    type: 'alert-error',
                });
            }
        });
    }
}

// FILE DOCUMENTED
